export default {
  // container: (base, state) => ({
  //   ...base,
  //   zIndex: "999",
  // }),
  // menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  clearIndicator: (base) => ({
    ...base,
    color: "rgb(153, 153, 153)",
    transition: "color 0.2s",
    ":hover": {
      color: "#ff944d",
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "rgb(153, 153, 153)",
    transition: "color 0.2s",
    ":hover": {
      color: "#ff944d",
    },
  }),
  noOptionsMessage: (provided, state) => {
    return { ...provided };
  }, //
  option: (provided, state) => {
    let bColor = "transparent";
    let tColor = "#777";
    if (state.isFocused) {
      bColor = "#ff944d";
      tColor = "#fff";
    }

    return {
      ...provided,
      padding: 10,
      paddingLeft: "20px",
      backgroundColor: bColor,
      color: tColor,
      ":hover": {
        backgroundColor: "#ff944d",
        color: "#fff",
      },
    };
  },
  control: (provided, state) => () => {
    // none of react-select's styles are passed to <Control />

    let border = "hsl(0, 0%, 80%)";

    if (state.isFocused) {
      border = "rgb(204, 204, 204)";
    }

    return {
      ...provided,
      outline: "#f60 none 0px !important",
      backgroundColor: "#fff",
      boxShadow: "none",
      borderColor: border,
      ":active, :hover": {
        borderColor: "#f60",
      },
      width: 265,
      height: 42,
      "@media only screen and (max-width: 767px)": {
        width: 230,
      },
      "& > div:nth-child(1)": {
        marginRight: "-1px",
      },
    };
  },
  valueContainer: (provided, state) => ({
    ...provided,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return {
      ...provided,
      opacity,
      transition,
      color: "rgb(128, 128, 128)",
    };
  },
  indicatorSeparator: (provided, state) => ({
    display: "none",
  }),
  menu: (provided, state) => {
    return {
      ...provided,
      "& > div": {
        maxHeight: "unset",
      },
      width: 265,
      // left: "1%",
      "@media only screen and (max-width: 767px)": {
        width: 230,
        // left: "5.25%",
      },

      "@media only screen and (min-width: 767px)": {
        // left: "3.8%",
      },
      "@media only screen and (device-width: 767px)": {
        //  left: "3.8%",
      },
      "@media only screen and (min-width: 1200px)": {
        //  left: "2.8%",
      },
    };
  },
  placeholder: (provided, state) => {
    let tColor = "#777";
    if (state.isDisabled) {
      tColor = "rgba(128, 128, 128, 0.5)";
    }
    return {
      ...provided,
      color: tColor,
    };
  },
  menuList: (provided, state) => ({
    ...provided,
  }),
};